// ======================================================================
// File Name       : scoringReport
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import { commonCallApi } from '../../utils/ApiUtils';

export function scoringReportSearchRequest(params) {
  return commonCallApi({
    path: 'reportOperation/GetList',
    data: params,
  });
}

export function scoringReportEdit(param) {
  return commonCallApi({
    path: 'reportOperation/EditByCorrector',
    data: param,
    institutionId: 1,
  });
}

export function getDrilLDetailRequest(param) {
  return commonCallApi({
    path: 'reportOperation/GetDetailDrill',
    data: param,
    institutionId: 1,
  });
}

// #7404 START
export function getDrillTopInfo(param) {
  return commonCallApi({
    path: 'DrillTopInfo',
    data: param,
    drillServer: true,
  });
}

export function getEachQuestion(param) {
  return commonCallApi({
    path: 'EachQuestion',
    data: param,
    drillServer: true,
  });
}
// #7404 END
